//= =================================== React-IMPORT ==================================================================//
import React from 'react';
import clsx from 'clsx';
//= =================================== AEM-IMPORT ====================================================================//
//= =================================== MUI-IMPORT ====================================================================//
import { makeStyles } from '@material-ui/core/styles';
//= =================================== Icon ==========================================================================//
import SvgIcon from '@material-ui/core/SvgIcon';
//= =================================== App component =================================================================//
//= =================================== Utility =======================================================================//
//= =================================== Redux action ==================================================================//
//= =================================== Styles ========================================================================//
const useStyles = makeStyles(() => ({
  root: {
    fill: 'white',
  },
}));
//= =================================== Class definition ==============================================================//
const ClockInfoIcon = (props) => {
  const classes = useStyles();

  return (
    <SvgIcon
      width="74"
      height="74"
      viewBox="0 0 74 74"
      className={clsx(classes.root, props.className)}
    >
      <path
        d="M68.5182 33.3898C68.5182 51.8305 53.5689 66.7798 35.1283 66.7798C16.6876 66.7798 1.73828 51.8305 1.73828 33.3898C1.73828 14.9491 16.6876 -0.000167847 35.1283 -0.000167847C53.5689 -0.000167847 68.5182 14.9491 68.5182 33.3898Z"
        fill="#E0E0E0"
      />
      <path
        d="M62.5168 33.39C62.5168 48.5155 50.2553 60.7773 35.1295 60.7773C20.0039 60.7773 7.74219 48.5155 7.74219 33.39C7.74219 18.2644 20.0039 6.00278 35.1295 6.00278C50.2553 6.00278 62.5168 18.2644 62.5168 33.39Z"
        fill="#F3F3F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.622 54.4082L35.59 33.9777L35.59 6.00215C35.5178 5.96989 35.4433 5.93807 35.3665 5.90674C28.3098 5.86752 21.2408 8.54002 15.8567 13.9241C5.16647 24.6144 5.16632 41.9466 15.8567 52.637C25.9198 62.7 41.8684 63.2905 52.622 54.4082Z"
        fill="#E8E8E8"
      />
      <path
        d="M34.7358 12.4341H34.6811C34.2854 12.4341 33.9648 12.1135 33.9648 11.7181V8.13119C33.9648 7.73575 34.2854 7.41498 34.6811 7.41498H34.7358C35.1313 7.41498 35.452 7.73575 35.452 8.13119V11.7181C35.452 12.1135 35.1313 12.4341 34.7358 12.4341Z"
        fill="#CACACA"
      />
      <path
        d="M34.8257 60.1152H34.7709C34.3755 60.1152 34.0547 59.7949 34.0547 59.3992V55.8123C34.0547 55.4169 34.3755 55.0963 34.7709 55.0963H34.8257C35.2213 55.0963 35.5419 55.4169 35.5419 55.8123V59.3992C35.5419 59.7949 35.2213 60.1152 34.8257 60.1152Z"
        fill="#CACACA"
      />
      <path
        d="M8.40234 33.8392V33.7842C8.40234 33.3888 8.72311 33.068 9.11855 33.068H12.7054C13.1009 33.068 13.4214 33.3888 13.4214 33.7842V33.8392C13.4214 34.2346 13.1009 34.5552 12.7054 34.5552H9.11855C8.72311 34.5552 8.40234 34.2346 8.40234 33.8392Z"
        fill="#CACACA"
      />
      <path
        d="M55.8555 33.8392V33.7842C55.8555 33.3888 56.1762 33.068 56.5717 33.068H60.1586C60.554 33.068 60.8746 33.3888 60.8746 33.7842V33.8392C60.8746 34.2346 60.554 34.5552 60.1586 34.5552H56.5717C56.1762 34.5552 55.8555 34.2346 55.8555 33.8392Z"
        fill="#CACACA"
      />
      <path
        d="M35.0151 33.4861L34.9442 33.4666C34.4314 33.3251 34.1098 32.8691 34.2259 32.448L38.8268 15.7687C38.9429 15.3476 39.4527 15.1212 39.9656 15.2626L40.0365 15.2822C40.5493 15.4236 40.8709 15.8795 40.7548 16.3005L36.1539 32.9799C36.0378 33.4009 35.5279 33.6276 35.0151 33.4861Z"
        fill="#CACACA"
      />
      <path
        d="M34.9933 33.5298L35.0312 33.4668C35.3058 33.0111 35.2249 32.4591 34.8508 32.2337L24.6017 26.0587C24.2277 25.8334 23.702 26.0198 23.4274 26.4755L23.3894 26.5385C23.1147 26.9945 23.1956 27.5464 23.5695 27.7717L33.8187 33.9468C34.1928 34.1722 34.7185 33.9858 34.9933 33.5298Z"
        fill="#CACACA"
      />
      <path
        d="M38.5034 33.7654C38.5034 35.8375 36.8238 37.5171 34.7517 37.5171C32.6798 37.5171 31 35.8375 31 33.7654C31 31.6933 32.6798 30.0137 34.7517 30.0137C36.8238 30.0137 38.5034 31.6933 38.5034 33.7654Z"
        fill="#CACACA"
      />
      <circle
        cx="55.8636"
        cy="55.3636"
        r="16.3636"
        fill="#F9BE00"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="55.8619"
        y1="47.1817"
        x2="55.8619"
        y2="57.409"
        stroke="white"
        strokeWidth="4.09091"
        strokeLinecap="round"
      />
      <circle cx="55.8619" cy="63.5455" r="2.04545" fill="white" />
    </SvgIcon>
  );
};
//= =================================== Component props ===============================================================//

//= =================================== Redux map props ===============================================================//

//= =================================== Export ========================================================================//
export default ClockInfoIcon;
